/** API route map: URLS.Controller.CandidateExperience */
export const CandidateExperience = {
      Name: 'CandidateExperience/',
      GetExperiences: 'get-all',
      AddExperience: 'add',
      UpdateExperience: 'update',
      DeleteExperience: 'delete',
};
